import {
    IProdutoPainelImplantacao,
    IPainelImplantacao,
} from "../../../Interfaces/Vendas/PainelImplantacao/PainelImplantacaoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetProdutosPorUnidadeEquipeServices(
    idEmpreendimento: number
) {
    return Service(
        Axios.get<Array<IProdutoPainelImplantacao>>(
            `/home/produtos/getprodutosporunidadeequipe?idEmpreendimento=${idEmpreendimento}`
        )
    );
}

export async function GetProdutosPainelImplantacaoService(
    idEmpreendimento: number
) {
    return Service(
        Axios.get<IPainelImplantacao>(
            `/vendas/gestaoprodutos/getprodutospainelimplantacao?idEmpreendimento=${idEmpreendimento}`
        )
    );
}
